export default __webpack_public_path__ + "static/media/video-thumbnail.dd827d92.png";